import api from './axios';

export const authAPI = {
  register:       (data) => api.post('/register', data),
  login:          (data) => api.post('/login', data),
  logout:         ()     => api.post('/logout'),
  changePassword: (data) => api.put('/change-password', data),
};
